module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-vi.9656506e.mp4";